import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useUbi from '@di-shared/features/ubi/useUbi';
import useUnitConverter from '@di-shared/utils/useUnitConverter';

function UbiDiscountBannerKr({vin}: {vin: string}) {
  const {t} = useInferableTranslation();
  const {getDiscountPredictionCase, ubiData} = useUbi({vin});
  const {ubiCase, ...args} = getDiscountPredictionCase();
  const {convertDistanceSymbol, convertDistanceValue} = useUnitConverter();

  switch (ubiCase) {
    case 1:
      return (
        <div className="section_container_box">
          <p
            className="discount_info_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20330')}
          </p>
        </div>
      );
    case 2:
      const remainDistance500 = 500 - (args.N as number) || 0;
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20100')}</strong>
          <p className="discount_info_desc">{t('T20039_$n', {n: `${convertDistanceValue(args.N)}${convertDistanceSymbol(args.N)}`})}</p>
          <div className="discount_info_progress">
            <div className="slider slider_progress">
              <label
                htmlFor="distanceProgress"
                className="blind"
              >
                {t('T10141')}
              </label>
              <div className="slider_box">
                <progress
                  id="distanceProgress"
                  className="slider_bar"
                  max="500"
                  value={remainDistance500}
                ></progress>
              </div>
            </div>
            <div className="progress_text">
              <span className="progress_value">
                <span className="blind">{t('T10142')}</span>
                {convertDistanceValue(remainDistance500)}
                {convertDistanceSymbol(remainDistance500)}
              </span>
              <span className="progress_max">
                <span className="blind">{t('T10143')}</span>
                {convertDistanceValue(500)}
                {convertDistanceSymbol(500)}
              </span>
            </div>
          </div>
        </div>
      );
    case 3:
      const remainDistance1000 = 1000 - (args.N as number) || 0;
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20331')}</strong>
          <p className="discount_info_desc">{t('T20333_$n', {n: `${convertDistanceValue(args.N)}${convertDistanceSymbol(args.N)}`})}</p>
          <div className="discount_info_progress">
            <div className="slider slider_progress">
              <label
                htmlFor="distanceProgress"
                className="blind"
              >
                {t('T10141')}
              </label>
              <div className="slider_box">
                <progress
                  id="distanceProgress"
                  className="slider_bar"
                  max="1000"
                  value={remainDistance1000}
                ></progress>
              </div>
            </div>
            <div className="progress_text">
              <span className="progress_value">
                <span className="blind">{t('T10142')}</span>
                {convertDistanceValue(remainDistance1000)}
                {convertDistanceSymbol(remainDistance1000)}
              </span>
              <span className="progress_max">
                <span className="blind">{t('T10143')}</span>
                {convertDistanceValue(1000)}
                {convertDistanceSymbol(1000)}
              </span>
            </div>
          </div>
        </div>
      );
    case 4:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T10140')}</strong>
          <p
            className="discount_info_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20034_$score_$n', {score: ubiData.safetyDrvScore, n: args.n})}
          </p>
        </div>
      );
    case 5:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20101')}</strong>
          <p
            className="discount_info_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20102_$c_$e', {c: `${convertDistanceValue(args.d)}${convertDistanceSymbol(args.d)}`, e: args.f})}
          </p>
        </div>
      );
    case 6:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20211')}</strong>
          <p
            className="discount_info_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20102_$c_$e', {c: `${convertDistanceValue(args.e)}${convertDistanceSymbol(args.e)}`, e: args.g})}
          </p>
        </div>
      );
    case 7:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20105')}</strong>
          <p className="discount_info_desc">{t('T20106_$a', {a: args.a})}</p>
        </div>
      );
    case 8:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20105')}</strong>
          <p className="discount_info_desc">{t('T20332_$d', {d: args.d})}</p>
        </div>
      );
    case 9:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20103')}</strong>
          <p
            className="discount_info_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20104')}
          </p>
        </div>
      );
    case 10:
      return (
        <div className="section_container_box">
          <strong className="discount_info_title">{t('T20038')}</strong>
          <p
            className="discount_info_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20104')}
          </p>
        </div>
      );

    default:
      return null;
  }
}

export default UbiDiscountBannerKr;
